import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/web.dom-collections.for-each";
import { __assign, __awaiter, __generator, __read, __spread, __values } from "tslib";
import Vue from 'vue';
import { isUndef } from '@/lib/utils';
import TeamApply from '@/models/teamApply';

function initRecruitRank(map, activityId) {
  if (!map[activityId]) {
    Vue.set(map, activityId, {
      list: [],
      loaded: false,
      requesting: false,
      user: null
    });
  }
}

function initAffectList(map, key) {
  if (!map[key]) {
    Vue.set(map, key, {
      list: [],
      loaded: false,
      requesting: false
    });
  }
}

var m = {
  namespaced: true,
  state: function state() {
    return {
      activity: {},

      /** 战队列表 */
      teamListMap: {},
      teamDataMap: {},
      teamInfoMap: {},

      /** 招募榜单 */
      recruitRank: {},
      affectStat: {},
      affectList: {},
      activityIdMapPrizeList: {},
      teamSignInMap: {},
      teamSignInDetailMap: {},
      userSignInCalendarMap: {},
      userSignInStatic: {},
      inviteNews: {},
      newsRequesing: false,
      monitorInviteCard: {},
      recommendTeamList: {
        order_team: [],
        recommend_team: []
      },
      monitorQuestion: null,
      monitorQuestionScore: null,
      teamApply: null,
      lastTeamInfo: null,
      teamVisiableMap: {},
      teamInfo: null
    };
  },
  getters: {
    /** 存在战队的activityId列表 */
    monitorActivityIds: function monitorActivityIds(state, getters, rootState, rootGetters) {
      return rootGetters['activity/allMonitorActivityIds'].filter(function (activityId) {
        var teamList = state.teamListMap[activityId];
        return teamList && teamList.length > 0;
      });
    },

    /** 是否有管理的战队 */
    hasMonitorTeam: function hasMonitorTeam(state, getters) {
      return getters.monitorActivityIds.length > 0;
    },
    hasTargetMonitorTeam: function hasTargetMonitorTeam(state, getters, rootState, rootGetters) {
      var activityId = rootGetters['activity/activityId'];
      var teamList = state.teamListMap[activityId];
      return teamList && teamList.length > 0;
    },

    /** 最近可管理的活动id */
    mainMonitorActivityId: function mainMonitorActivityId(state, getters, rootState) {
      var e_1, _a;

      var activityIds = getters.monitorActivityIds || [];

      if (activityIds.length === 0) {
        return;
      }

      try {
        for (var activityIds_1 = __values(activityIds), activityIds_1_1 = activityIds_1.next(); !activityIds_1_1.done; activityIds_1_1 = activityIds_1.next()) {
          var activityId = activityIds_1_1.value;
          var basicInfo = rootState.activity.basicInfo[activityId]; // 在周期内

          if (basicInfo && (basicInfo.startMonitorApply || basicInfo.startParticipation || basicInfo.startSignIn) && !(basicInfo.closeMonitorApply && basicInfo.closeParticipation && basicInfo.closeSignIn)) {
            return activityId;
          }
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (activityIds_1_1 && !activityIds_1_1.done && (_a = activityIds_1["return"])) _a.call(activityIds_1);
        } finally {
          if (e_1) throw e_1.error;
        }
      }

      return activityIds[0];
    },

    /** 最近可以申请成为队长 */
    mainMonitorApplyActivityId: function mainMonitorApplyActivityId(state, getters, rootState, rootGetters) {
      var e_2, _a;

      var activityIds = rootGetters['activity/allMonitorActivityIds'];

      try {
        for (var activityIds_2 = __values(activityIds), activityIds_2_1 = activityIds_2.next(); !activityIds_2_1.done; activityIds_2_1 = activityIds_2.next()) {
          var activityId = activityIds_2_1.value;
          var basicInfo = rootState.activity.basicInfo[activityId];

          if (basicInfo && basicInfo.startMonitorApply && !basicInfo.closeMonitorApply) {
            return activityId;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (activityIds_2_1 && !activityIds_2_1.done && (_a = activityIds_2["return"])) _a.call(activityIds_2);
        } finally {
          if (e_2) throw e_2.error;
        }
      }

      return activityIds[0];
    }
  },
  mutations: {
    /**
     * 记录活动列表
     */
    setActivity: function setActivity(state, _a) {
      var mode = _a.mode,
          list = _a.list;
      Vue.set(state.activity, mode, list);
    },
    initActivityList: function initActivityList(state, _a) {
      var key = _a.key;
      Vue.set(state.activity, key, {
        list: [],
        loaded: false,
        req: false
      });
    },
    concatActivityList: function concatActivityList(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.activity[key].list = state.activity[key].list.concat(list);
    },
    setActivityListLoaded: function setActivityListLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.activity[key].loaded = loaded;
    },
    setActivityListReq: function setActivityListReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.activity[key].req = req;
    },

    /**
     * 记录战队列表
     */
    setTeamList: function setTeamList(state, _a) {
      var activityId = _a.activityId,
          teamList = _a.teamList;
      Vue.set(state.teamListMap, activityId, teamList);
    },

    /**
     * 记录战队信息
     */
    setTeamData: function setTeamData(state, _a) {
      var teamId = _a.teamId,
          data = _a.data;
      Vue.set(state.teamDataMap, teamId, data);
    },
    setTeamInfo: function setTeamInfo(state, _a) {
      var teamId = _a.teamId,
          info = _a.info;
      Vue.set(state.teamInfoMap, teamId, info);
    },

    /**
     * 添加招募排行数据
     */
    concatRecruitRank: function concatRecruitRank(state, _a) {
      var _b;

      var activityId = _a.activityId,
          list = _a.list;
      initRecruitRank(state.recruitRank, activityId);

      (_b = state.recruitRank[activityId].list).push.apply(_b, __spread(list));
    },

    /**
     * 记录招募排行是否加载完成
     */
    setRecruitRankLoaded: function setRecruitRankLoaded(state, _a) {
      var activityId = _a.activityId,
          loaded = _a.loaded;
      state.recruitRank[activityId].loaded = loaded;
    },

    /**
     * 记录招募排行是否正在请求
     */
    setRecruitRankReq: function setRecruitRankReq(state, _a) {
      var activityId = _a.activityId,
          req = _a.req;
      state.recruitRank[activityId].requesting = req;
    },

    /**
     * 记录招募排行用户数据
     */
    setRecruitRankUser: function setRecruitRankUser(state, _a) {
      var activityId = _a.activityId,
          user = _a.user;
      state.recruitRank[activityId].user = user;
    },

    /**
     * 记录影响数据
     */
    setAffectStat: function setAffectStat(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          affectStat = _a.affectStat;
      var key = [activityId, teamId].join('_');
      Vue.set(state.affectStat, key, affectStat);
    },

    /**
     * 添加影响人数
     */
    concatAffectList: function concatAffectList(state, _a) {
      var _b;

      var activityId = _a.activityId,
          teamId = _a.teamId,
          joined = _a.joined,
          list = _a.list;
      var key = [activityId, teamId, joined].join('_');
      initAffectList(state.affectList, key);

      (_b = state.affectList[key].list).push.apply(_b, __spread(list));
    },

    /**
     * 记录是否全部加载
     */
    setAffectListLoaded: function setAffectListLoaded(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          joined = _a.joined,
          loaded = _a.loaded;
      var key = [activityId, teamId, joined].join('_');
      initAffectList(state.affectList, key);
      Vue.set(state.affectList[key], 'loaded', loaded);
    },

    /**
     * 记录是否正字啊请求
     */
    setAffectListReq: function setAffectListReq(state, _a) {
      var activityId = _a.activityId,
          teamId = _a.teamId,
          joined = _a.joined,
          req = _a.req;
      var key = [activityId, teamId, joined].join('_');
      initAffectList(state.affectList, key);
      Vue.set(state.affectList[key], 'requesting', req);
    },

    /**
     * 记录prizeList
     */
    setPrizeList: function setPrizeList(state, _a) {
      var activityId = _a.activityId,
          prizeList = _a.prizeList;
      Vue.set(state.activityIdMapPrizeList, activityId, prizeList);
    },

    /** 记录战队某天的打卡概况 */
    setTeamSignInMap: function setTeamSignInMap(state, _a) {
      var teamId = _a.teamId,
          date = _a.date,
          data = _a.data;
      Vue.set(state.teamSignInMap[teamId], date, data);
    },
    setTeamSignInDetailMap: function setTeamSignInDetailMap(state, _a) {
      var teamId = _a.teamId,
          date = _a.date,
          type = _a.type,
          data = _a.data;
      data.forEach(function (item, index) {
        item.rank = index + 1;
      });
      Vue.set(state.teamSignInDetailMap[teamId][date], type, data);
    },
    setUserSignInCalendarMap: function setUserSignInCalendarMap(state, _a) {
      var activityId = _a.activityId,
          userId = _a.userId,
          month = _a.month,
          data = _a.data;
      var key = activityId + '_' + userId;
      Vue.set(state.userSignInStatic, key, {
        nickname: data.nickname,
        avatar: data.avatar,
        total_days: data.total_days,
        total_distance: data.total_distance,
        future_day: data.future_day,
        need_day: data.need_day
      });
      Vue.set(state.userSignInCalendarMap[userId], month, data);
    },
    setNews: function setNews(state, _a) {
      var activityId = _a.activityId,
          news = _a.news;
      state.inviteNews[activityId] = news;
    },
    setNewsRequesting: function setNewsRequesting(state, requesting) {
      state.newsRequesing = requesting;
    },
    setMonitorInviteCard: function setMonitorInviteCard(state, _a) {
      var activityId = _a.activityId,
          card = _a.card;
      Vue.set(state.monitorInviteCard, activityId, card);
    },
    setMonitorRecommendTeamList: function setMonitorRecommendTeamList(state, data) {
      state.recommendTeamList = data;
    },

    /**
     * 记录笔试题
     */
    setMonitorQuestion: function setMonitorQuestion(state, question) {
      state.monitorQuestion = question;
    },

    /**
     * 记录笔试题分数
     */
    setMonitorQuestionScore: function setMonitorQuestionScore(state, score) {
      state.monitorQuestionScore = score;
    },

    /**
     * 记录申请信息
     */
    setTeamApply: function setTeamApply(state, teamApply) {
      state.teamApply = teamApply;
    },

    /**
     * 记录上一次的创建队伍信息
     */
    setLastTeamInfo: function setLastTeamInfo(state, teamApply) {
      state.lastTeamInfo = teamApply;
    },
    setTeamVisiableInfo: function setTeamVisiableInfo(state, _a) {
      var teamId = _a.teamId,
          data = _a.data;
      Vue.set(state.teamVisiableMap, teamId, data && data.show);
    },
    setTeamInfoData: function setTeamInfoData(state, info) {
      state.teamInfo = info;
    }
  },
  actions: {
    /**
     * 活动列表
     */
    getActivityList: function getActivityList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var mode = _b.mode,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = mode;
              wrap = state.activity[key];

              if (!wrap) {
                commit('initActivityList', {
                  key: key
                });
                wrap = state.activity[key];
              }

              if (wrap.req || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setActivityListReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/activity_list', {
                params: {
                  mode: mode,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatActivityList', {
                  key: key,
                  list: list
                });

                if (list.length < count) {
                  commit('setActivityListLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setActivityListReq', {
                key: key,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队列表
     */
    getTeamList: function getTeamList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              // 数据缓存
              if (state.teamListMap[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_list', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamList', {
                  activityId: activityId,
                  teamList: rdata.data
                });
              } else {
                commit('setTeamList', {
                  activityId: activityId,
                  teamList: []
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得战队信息
     */
    getTeamData: function getTeamData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.teamDataMap[teamId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_data', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamData', {
                  teamId: teamId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得战队信息
     */
    getTeamInfo: function getTeamInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.teamInfoMap[teamId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_info', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamInfo', {
                  teamId: teamId,
                  info: new TeamApply(rdata.data)
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得上次创建队伍信息
     */
    getLastTeamInfo: function getLastTeamInfo(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/last_team_info')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setLastTeamInfo', new TeamApply(rdata.data));
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新战队信息
     */
    updateTeamInfo: function updateTeamInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var teamId = _b.teamId;
      return __awaiter(this, void 0, void 0, function () {
        var teamApply, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              teamApply = state.teamInfoMap[teamId];
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/monitor/team_info', __assign({
                id: teamId
              }, teamApply === null || teamApply === void 0 ? void 0 : teamApply.toRaw()))];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , dispatch('getTeamInfo', {
                teamId: teamId,
                forceUpdate: true
              })];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 招募排行
     */
    getRecruitRank: function getRecruitRank(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              initRecruitRank(state.recruitRank, activityId);
              wrap = state.recruitRank[activityId];
              end = offset + count;

              if (end <= wrap.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < wrap.list.length) {
                offset = wrap.list.length;
                count = end - offset;
              }

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              commit('setRecruitRankReq', {
                activityId: activityId,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/rank', {
                params: {
                  id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatRecruitRank', {
                  activityId: activityId,
                  list: rdata.data.list
                });

                if (rdata.data.list.length < count) {
                  commit('setRecruitRankLoaded', {
                    activityId: activityId,
                    loaded: true
                  });
                }

                if (rdata.data.current) {
                  commit('setRecruitRankUser', {
                    activityId: activityId,
                    user: rdata.data.current
                  });
                }
              }

              commit('setRecruitRankReq', {
                activityId: activityId,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取影响状态
     */
    getAffectStat: function getAffectStat(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/affect_stats', {
                params: {
                  activity_id: activityId,
                  team_id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAffectStat', {
                  activityId: activityId,
                  teamId: teamId,
                  affectStat: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取影响人员列表
     */
    getAffectList: function getAffectList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          joined = _b.joined,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = [activityId, teamId, joined].join('_');
              initAffectList(state.affectList, key);
              wrap = state.affectList[key];

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;

              if (end <= wrap.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < wrap.list.length) {
                offset = wrap.list.length;
                count = end - offset;
              }

              commit('setAffectListReq', {
                activityId: activityId,
                teamId: teamId,
                joined: joined,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/affect_list', {
                params: {
                  activity_id: activityId,
                  team_id: teamId,
                  joined: joined,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatAffectList', {
                  activityId: activityId,
                  teamId: teamId,
                  joined: joined,
                  list: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setAffectListLoaded', {
                    activityId: activityId,
                    teamId: teamId,
                    joined: joined,
                    loaded: true
                  });
                }
              }

              commit('setAffectListReq', {
                activityId: activityId,
                teamId: teamId,
                joined: joined,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 礼品列表
     */
    getPrizeList: function getPrizeList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.activityIdMapPrizeList[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/prize_list', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setPrizeList', {
                  activityId: activityId,
                  prizeList: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队打卡信息概况
     */
    getTeamSignIn: function getTeamSignIn(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          date = _b.date,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.teamSignInMap[teamId]) {
                Vue.set(state.teamSignInMap, teamId, {});
              }

              if (state.teamSignInMap[teamId][date] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_sign_in', {
                params: {
                  activity_id: activityId,
                  team_id: teamId,
                  date: date
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamSignInMap', {
                  teamId: teamId,
                  date: date,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队打卡详情
     * @param teamId 战队id
     * @param date 日期 格式 'Y-m-d'
     * @param type all yes no  全部 打卡成功 审核未通过或者未打卡
     */
    getTeamSignInDetail: function getTeamSignInDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          date = _b.date,
          type = _b.type,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.teamSignInDetailMap[teamId]) {
                Vue.set(state.teamSignInDetailMap, teamId, {});
              }

              if (!state.teamSignInDetailMap[teamId][date]) {
                Vue.set(state.teamSignInDetailMap[teamId], date, {});
              }

              if (state.teamSignInDetailMap[teamId][date][type] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_sign_in_detail', {
                params: {
                  team_id: teamId,
                  date: date,
                  type: type
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamSignInDetailMap', {
                  teamId: teamId,
                  date: date,
                  type: type,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 战队中某个队员打卡日历信息
     * @param activityId 活动id
     * @param userId 用户Id
     * @param month 日期 格式 'Y-m'
     */
    getUserSignInCalendar: function getUserSignInCalendar(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          userId = _b.userId,
          month = _b.month,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.userSignInCalendarMap[userId]) {
                Vue.set(state.userSignInCalendarMap, userId, {});
              }

              if (state.userSignInCalendarMap[userId][month] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/team_sign_in_calendar', {
                params: {
                  activity_id: activityId,
                  team_id: teamId,
                  user_id: userId,
                  month: month
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setUserSignInCalendarMap', {
                  activityId: activityId,
                  userId: userId,
                  month: month,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 最新战报
     * @param activityId
     * @param count
     * @param lastId
     * @param forceUpdate
     */
    getNews: function getNews(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (isUndef(state.inviteNews[activityId])) {
                Vue.set(state.inviteNews, activityId, []);
              }

              if (state.newsRequesing) {
                return [2
                /*return*/
                ];
              }

              commit('setNewsRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/monitor_invite_count', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              commit('setNewsRequesting', false);

              if (rdata.status === 0) {
                commit('setNews', {
                  activityId: activityId,
                  news: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得战队邀请卡
     *
     * @param {string} activityId
     */
    getInviteCard: function getInviteCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var temp, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              temp = state.monitorInviteCard[activityId];

              if (temp && !forceUpdate) {
                return [2
                /*return*/
                , {
                  status: 0,
                  data: temp
                }];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/monitor_invite_card', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setMonitorInviteCard', {
                  activityId: activityId,
                  card: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取推荐战队
     * @param {string} activityId 必填
     * @param {string} teamId 战队id 可选
     * @param {string} distance 期待战队的所在组别 可选
     * @param {number} cityId 期待战队所在城市 可选
     * @param {number} activitySpecialId 主题活动id 可选
     */
    getRecommendTeams: function getRecommendTeams(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId,
          distance = _b.distance,
          cityId = _b.cityId,
          activitySpecialId = _b.activitySpecialId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/recommend_team_list', {
                params: {
                  activity_id: activityId,
                  team_id: teamId,
                  distance: distance,
                  city_id: cityId ? cityId : undefined,
                  activity_special_id: activitySpecialId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setMonitorRecommendTeamList', rdata.data);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 获取笔试题
     */
    getMonitorQuestion: function getMonitorQuestion(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/monitor_question')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMonitorQuestion', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提交答案
     */
    answerMonitorQuestion: function answerMonitorQuestion(context, result) {
      return __awaiter(this, void 0, void 0, function () {
        var answer, key, response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              answer = [];

              for (key in result) {
                if (result[key]) {
                  answer.push({
                    question: key,
                    answer: result[key]
                  });
                }
              }

              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/activity/answer_monitor_question', {
                answer: answer
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setMonitorQuestionScore', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取申请队伍信息
     */
    getApplyTeam: function getApplyTeam(context) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor_apply/team_info')];

            case 1:
              response = _a.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTeamApply', new TeamApply(rdata.data));
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提交申请队伍信息
     */
    applyTeam: function applyTeam(context) {
      return __awaiter(this, void 0, void 0, function () {
        var apply, response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              apply = context.state.teamApply;
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/monitor_apply/team_info', __assign({}, apply.toRaw()))];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取队伍是否在首页展示状态
     */
    getTeamVisiableInfo: function getTeamVisiableInfo(context, _a) {
      var teamId = _a.teamId,
          forceUpdate = _a.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (context.state.teamVisiableMap[teamId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/team/info', {
                params: {
                  id: teamId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setTeamVisiableInfo', {
                  teamId: teamId,
                  data: rdata.data
                });
                context.commit('setTeamInfoData', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新队伍展示状态
     */
    updateTeamVisiableInfo: function updateTeamVisiableInfo(context, _a) {
      var teamId = _a.teamId,
          show = _a.show;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/team/show', {
                id: teamId,
                show: show ? 1 : 0
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;